<template>
    <div class="form-group">
        <label>{{ label }}
            <required-icon v-if="required"></required-icon>
            <img src="/storage/info.png" height="15" v-b-tooltip="tooltip" v-if="tooltip !== ''"/>
        </label>
        <input type="text" v-model="innerValue" class="form-control"/>
        <slot name="afterInput"></slot>
        <small class="text-danger" v-if="errors[errorKey]">{{ errors[errorKey][0] }}</small>
    </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'
export default {
    name: 'LGTInput',
    directives: { 'b-tooltip': VBTooltip },
    props: {
        value: {
            type: [String, null],
            default: null
        },
        label: {
            type: String,
            required: true
        },
        errorKey: {
            type: String,
            required: true
        },
        errors: {
            type: Object,
            required: true
        },
        required: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            innerValue: null,
        };
    },
    watch: {
        value: {
            handler: function(val) {
                this.innerValue = val;
            },
            immediate: true
        },
        innerValue(val) {
            this.$emit("input", val);
        }
    }
}
</script>
